import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
// import {getToken} from '@/utils/auth' // 验权
import api from "./utils/api";
const whiteList = ['/login', '/404','/userList','/register','/reset','/customers','/sharecharts','/shareuserlist','/showpage'] //白名单,不需要登录的路由
router.beforeEach((to, from, next) => {


  let param = {};
  param.userId = store.getters.userId;
  param.userName = store.getters.nickname;
  param.userRole = store.getters.roleId;
  param.roleName = store.getters.role;
  param.path = to.path;
  param.pathName = to.name;
  param.actionType = 1;



  // api({
  //   url:'/log/addLog',
  //   params:param,
  //   method:"POST"
  // }).then(data=>{
  //
  // });


  NProgress.start()
  console.log("0")
  if (localStorage.getItem("hadLogin") === "1") {
    //如果已经登录
    // if (store.getters.roleId ===1  && store.getters.phoneCheck ===1){
     if (!store.getters.userId){

          // console.log("2")
          store.dispatch('GetInfo').then(() => {
            next({...to})

          })

        }else {
        next()
         }
        NProgress.done()




  } else if (whiteList.indexOf(to.path) !== -1) {
    console.log("5")
    //如果前往的路径是白名单内的,就可以直接前往
    next()
  }  else {
    console.log("6")
    //如果路径不是白名单内的,而且又没有登录,就跳转登录页面
    store.commit('RESET_USER')
    next('/login')
    NProgress.done() // 结束Progress
  }
})
router.afterEach(() => {
  NProgress.done() // 结束Progress
})
